// extracted by mini-css-extract-plugin
export default {"lds-ring":"LoadingSpinner_lds-ring__qUF8i"};